import { createSelector } from 'reselect';
import { createCollectionReducer } from 'next/lib/collections';
import { getCacheKey } from 'next/lib/caching';
import { queryFlowsMetricsAnalytics } from 'next/client/queries';
import { TYPE } from './actions';

export default createCollectionReducer(TYPE);

export const selectAccountAnalytics = (state, query = '') =>
  state[TYPE]?.[query] || [];

const selectFlowAnalytics = createSelector(
  selectAccountAnalytics,
  analytics => {
    return (
      analytics?.reduce((acc, result) => {
        acc[result.flow_id] = result;
        return acc;
      }, {}) || {}
    );
  }
);

export const selectFlowAnalyticsById = (state, flowId) =>
  selectFlowAnalytics(state, getCacheKey(queryFlowsMetricsAnalytics()))?.[
    flowId
  ];
